import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import SearchableSelect from './SearchableSelect';
import { fetchTrackingList } from '../services/api';
import _ from 'lodash' 
/*

OnSelect contract:

when an option is selected the onSelect callback
gets called with the patient object as its only arg
patient object:
{
  email,
  id,
  firstName,
  lastName,
  birthdate,
}

------------------------

onChange contract

optional callback for when user types into search bar, takes user's input as only arg

------------------------

customFilter contract:

optional sorting mechanism. sorts patient objects of form

{
  label: "firstName lastName (MM/DD/YYYY)",
  value: {
    email,
    id,
    firstName,
    lastName,
    birthdate,
  }
}

*/

function TrackingTypeSearch(props) {
  const {
    id,
    disabled,
    onSelect,
    onChange,
    errorMessage,
    status=false,
    customFilter = null,
    label = 'For Patient Yes',
    name = 'patientList',
    placeholder = 'Search for a patient...',
    noOptionsMessage="No match found",
    maxOptions = 20,
    searchable = true,
     classes: { selectInput },
  } = props;
  const [patients, setPatients] = useState([]);
  const [currentPatientId, setCurrentPatientId] = useState(null);

  // loading patient names
  useEffect(() => {
    (async () => {
    if(id){
      const patientList = await fetchTrackingList(id, null, 0, 20, status, null, null, null  );
     
       setPatients(
        patientList.map(p => ({
          label: p.typeOfTrack,
        }))
      );
    }
    })();
  }, [id, status]);

  // filtering patient names patient names appropriately when search bar is typed into
  const filterPatients = async patientName => {
    if (onChange) onChange(patientName);
    let filterData = patients.filter(
        customFilter ||
        ((patient, i) =>
          patient.label.toLowerCase().includes(patientName.toLowerCase()))
      )
      .slice(0, maxOptions);
      let jsonObject = filterData.map(JSON.stringify); 
      
      let uniqueSet = new Set(jsonObject); 
      let uniqueArray = Array.from(uniqueSet).map(JSON.parse); 
      return  uniqueArray;
   };

  const handleSelectionBeingMade = async patient => {
     if (patient) {
      setCurrentPatientId(patient.id);
       await onSelect(patient.label);
    } else {
      setCurrentPatientId(null);
       await onSelect(null)
    }
  };

  const getList = async(inputValue) =>{
    if(!id) return [];
    const patientList = await fetchTrackingList(id, null, 0, 20, status, null, null, null  );
        
    setPatients(patientList);
        return patientList
        .filter(
          customFilter ||
          ((patient, i) =>
            patient.label.toLowerCase().includes(inputValue.toLowerCase()))
        )
        .slice(0, maxOptions);
  }

   return (
    <SearchableSelect
      noOptionsMessage={noOptionsMessage}
      clearable
      disabled={disabled}
      searchable={searchable}
      fetchAsyncOptions={filterPatients}
      placeholder={placeholder}
      label={label}
      name={name}
      onChange={handleSelectionBeingMade}
      value={currentPatientId}
      options={[]}
      className={selectInput}
      error={!!errorMessage}
      errorMessages={errorMessage}
      getList={getList}
    />
  );
}

TrackingTypeSearch.propTypes = {
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  customFilter: PropTypes.func,
  placeholder: PropTypes.string,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  name: PropTypes.string,
  maxOptions: PropTypes.number,
  searchable: PropTypes.bool,
  disabled: PropTypes.bool,
  status: PropTypes.string
};

const styles = () => ({
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
});

export default withStyles(styles)(TrackingTypeSearch);


